import { reactive, ref } from 'vue';
import type ModalType from '@i22/td-longtail-vue-components/dist/components/dialog/modal.vue';
import type { ModalOpenProps } from '@i22/td-longtail-vue-components';

export const modalState = reactive<ModalOpenProps>({
  heading: undefined,
  ariaLabel: undefined,
  content: undefined,
  component: undefined,
  className: undefined,
  buttons: [],
  closeOnBackdrop: true,
  noMaxWidth: false,
  onCloseCallback: undefined,
});

export const modal = ref<typeof ModalType | undefined>(undefined);

export const resetModal = () => {
  modalState.heading = undefined;
  modalState.ariaLabel = undefined;
  modalState.content = undefined;
  modalState.component = undefined;
  modalState.className = undefined;
  modalState.buttons = [];
  modalState.noMaxWidth = false;
  modalState.closeOnBackdrop = true;
  modalState.onCloseCallback = undefined;
};

export const openModal = (props: ModalOpenProps) => {
  resetModal();
  modalState.buttons = props.buttons || [];
  Object.keys(props).forEach((key) => {
    // @ts-ignore
    modalState[key] = props[key];
  });

  modal.value?.openDialog();
};

export const onCloseModal = () => {
  if (modalState.onCloseCallback) {
    modalState.onCloseCallback();
  }
};

export const closeModal = () => {
  modal.value?.closeDialog();
  // We have to wait, otherwise the "onCloseCallback" won't be triggered.
  setTimeout(() => {
    resetModal();
  }, 1);
};
